<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="pb-3">
              <strong>
                {{ confirmMessage }}
              </strong>
            </v-row>

            <!-- 追加・変更確認画面 -->
            <div class="my-3" v-if="displayType === 'A' || displayType === 'M'">
              <!-- クラウド設定 -->
              <v-row>
                <v-col>
                  <h3>クラウド設定</h3>
                </v-col>
              </v-row>
              <!--KDDI GPU Cloudご契約番号-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="KDDI GPU Cloudご契約番号"
                    :value="cloudVnGpuDetail.cloudVnConnectCommon.mNumber"
                  />
                </v-col>
              </v-row>
              <!--ロケーション-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ロケーション"
                    :value="
                      $filter.enumTo(
                        cloudVnGpuDetail.cloudVnConnectCommon.location,
                        'location'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--接続先仮想ネットワーク（VPN/VN）名-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="接続先仮想ネットワーク(VPN/VN)名"
                    :value="
                      cloudVnGpuDetail.cloudVnConnectCommon.vpnVnCode.startsWith(
                        'B'
                      )
                        ? cloudVnGpuDetail.cloudVnConnectCommon.vpnVnCode
                        : cloudVnGpuDetail.cloudVnConnectCommon.vnName +
                          ':' +
                          cloudVnGpuDetail.cloudVnConnectCommon.vpnVnCode +
                          '(L3)'
                    "
                  />
                </v-col>
              </v-row>
              <!-- KBIテナントコード -->
              <v-row>
                <v-col>
                  <app-label-group
                    label="KBIテナントコード"
                    :value="cloudVnGpuDetail.cloudVnConnectCommon.kbiTenantCode"
                  />
                </v-col>
              </v-row>

              <!-- VNコネクト設定 -->
              <v-row class="mt-2">
                <v-col>
                  <h3>VNコネクト設定</h3>
                </v-col>
              </v-row>
              <!--品目-->
              <v-row>
                <v-col>
                  <app-label-group label="品目">
                    <template #value>
                      <div class="ml-3">
                        {{
                          cloudVnGpuDetail.cloudVnConnectCommon.bandwidthType
                        }}({{
                          $filter.bandwidthTo(
                            cloudVnGpuDetail.cloudVnConnectCommon.bandwidth
                          )
                        }})
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>
              <!--VNコネクト名（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="VNコネクト名(Act)"
                    :value="cloudVnGpuDetail.cloudVnConnectAct.vnConnectName"
                  />
                </v-col>
              </v-row>
              <!--VNコネクト名（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="VNコネクト名(Sby)"
                    :value="
                      cloudVnGpuDetail.cloudVnConnectSby
                        ? cloudVnGpuDetail.cloudVnConnectSby.vnConnectName
                        : '-'
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（共通） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(共通)</h3>
                </v-col>
              </v-row>
              <!--ルーティング種別-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ルーティング種別"
                    :value="cloudVnGpuDetail.cloudVnConnectCommon.routingType"
                  />
                </v-col>
              </v-row>
              <!--AS番号-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="AS番号"
                    :value="cloudVnGpuDetail.cloudVnConnectCommon.asNumber"
                  />
                </v-col>
              </v-row>
              <!--Maximum Prefix-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Maximum Prefix"
                    :value="
                      $filter.emptyTo(
                        cloudVnGpuDetail.cloudVnConnectCommon.maximumPrefix,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（Act） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(Act)</h3>
                </v-col>
              </v-row>
              <!--WANアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="WANアドレス"
                    :value="
                      $filter.emptyTo(
                        cloudVnGpuDetail.cloudVnConnectAct.wanAddress,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--ピアIPアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ピアIPアドレス"
                    :value="
                      $filter.emptyTo(
                        cloudVnGpuDetail.cloudVnConnectAct.peerIpAddress,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--Local Preference（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Local Preference"
                    :value="
                      $filter.enumTo(
                        cloudVnGpuDetail.cloudVnConnectAct.localPreference,
                        'localPreference'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--MED（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="MED"
                    :value="
                      $filter.enumTo(
                        cloudVnGpuDetail.cloudVnConnectAct.med,
                        'med'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!-- ルーティング情報（Sby） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(Sby)</h3>
                </v-col>
              </v-row>
              <template v-if="cloudVnGpuDetail.cloudVnConnectSby">
                <!--WANアドレス（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="WANアドレス"
                      :value="
                        $filter.emptyTo(
                          cloudVnGpuDetail.cloudVnConnectSby.wanAddress,
                          '-'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <!--ピアIPアドレス（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="ピアIPアドレス"
                      :value="
                        $filter.emptyTo(
                          cloudVnGpuDetail.cloudVnConnectSby.peerIpAddress,
                          '-'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <!--Local Preference（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="Local Preference"
                      :value="
                        $filter.enumTo(
                          cloudVnGpuDetail.cloudVnConnectSby.localPreference,
                          'localPreference'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <!--MED（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="MED"
                      :value="
                        $filter.enumTo(
                          cloudVnGpuDetail.cloudVnConnectSby.med,
                          'med'
                        )
                      "
                    />
                  </v-col>
                </v-row>
              </template>
              <div class="ml-3 mb-3" v-else><span>-</span></div>

              <template
                v-if="cloudVnGpuDetail.cloudVnConnectCommon.routeAggregation"
              >
                <!-- カスタム経路集約情報 -->
                <v-row class="mt-2">
                  <v-col>
                    <h3>カスタム経路集約情報</h3>
                  </v-col>
                </v-row>
                <!--経路集約-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="経路集約"
                      :value="
                        cloudVnGpuDetail.cloudVnConnectCommon.routeAggregation
                      "
                    />
                  </v-col>
                </v-row>

                <!--注意文言 : 追加確認画面又は変更確認画面のみ表示-->
                <template
                  v-if="
                    cloudVnGpuDetail.cloudVnConnectCommon.routeAggregation ===
                    'OFF'
                  "
                >
                  <v-row v-if="displayType === 'A' || displayType === 'M'">
                    <v-col>
                      <app-label-group
                        label="WVS2で学習している経路をすべて広報いたします。クラウド側の受信経路上限数を超過している場合は接続ができません。"
                      />
                    </v-col>
                  </v-row>
                </template>

                <!--経路集約アドレス-->
                <v-row v-else>
                  <v-col>
                    <app-label-group label="経路集約アドレス">
                      <template #value>
                        <template
                          v-if="
                            cloudVnGpuDetail.cloudVnConnectCommon
                              .routeAggregation === 'CUSTOM'
                          "
                        >
                          <div class="d-flex flex-wrap">
                            <span
                              class="ml-3"
                              v-for="(ip, index) in cloudVnGpuDetail
                                .cloudVnConnectCommon
                                .routeAggregationAddressList"
                              :key="index"
                            >
                              {{ ip }}
                            </span>
                          </div>
                        </template>
                        <template
                          v-else-if="
                            cloudVnGpuDetail.cloudVnConnectCommon
                              .routeAggregation === 'ON'
                          "
                        >
                          <span class="ml-3">0.0.0.0/0</span>
                        </template>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
              </template>

              <!--備考-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="備考"
                    :value="
                      $filter.emptyTo(
                        cloudVnGpuDetail.cloudVnConnectCommon.description,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
            </div>
            <template v-if="showNotice">
              <div class="font-weight-bold mt-5">
                VNコネクトを追加する前に、以下確認をしてください。
              </div>
              <v-sheet border rounded class="pa-2">
                <template
                  v-for="(notice, index) in noticeOptions"
                  :key="`${notice.text + index}`"
                >
                  <v-checkbox
                    v-model="checkedItems"
                    :value="notice.value"
                    :label="notice.text"
                    hide-details
                  />
                </template>
              </v-sheet>
            </template>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="ok"
              variant="flat"
              color="primary"
              :disabled="
                displayType === 'A'
                  ? !(checkedItems.length === noticeOptions.length)
                  : false
              "
              >はい</v-btn
            >
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CloudVnGpuDetail } from "@/apis/CloudVnGpuApi";

export default defineComponent({
  name: "MultiCloudGpuVnConnectionConfirm",
  props: {
    cloudVnGpuDetail: {
      type: Object as PropType<CloudVnGpuDetail>,
      required: true,
    },
    /** 画面表示モード：
     * A - 追加確認
     * M - 編集確認
     */
    displayType: {
      type: String as PropType<"A" | "M">,
      required: true,
    },
  },
  computed: {
    noticeOptions(): { text: string; value: string }[] {
      return [
        {
          text: "VNコネクト作成中はKDDI GPU Cloudの設定変更は実施しないこと",
          value: "CHECKED_NOT_CHANGE",
        },
        {
          text: "KDDI GPU Cloudご契約番号に誤りがないこと",
          value: "CHECKED_NOT_MISTAKE",
        },
      ];
    },
    showNotice(): boolean {
      switch (this.displayType) {
        case "A":
          return true;
        case "M":
        default:
          return false;
      }
    },
    confirmMessage(): string {
      switch (this.displayType) {
        case "A":
          return "こちらの内容でクラウド接続向けVN回線を追加します。よろしいですか？";
        case "M":
          return "こちらの内容でクラウド接続向けVN回線を変更します。よろしいですか？";
        default:
          throw new Error("wrong displayType!");
      }
    },
  },
  data() {
    return {
      checkedItems: [],
    };
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-checkbox .v-selection-control) {
  min-height: auto;
}
</style>
